import { render } from "./AddVip.vue?vue&type=template&id=c83a3a76&scoped=true"
import script from "./AddVip.vue?vue&type=script&lang=js"
export * from "./AddVip.vue?vue&type=script&lang=js"

import "./AddVip.vue?vue&type=style&index=0&id=c83a3a76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83a3a76"]])

export default __exports__